import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../data/mock';

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">What We Do</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">Our Services</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Quality plastering for your home. Walls finished smoothly, repairs done properly, jobs completed to a high standard.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-amber-200"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <span className="bg-amber-500 text-white text-sm font-medium px-3 py-1 rounded-full">
                    {service.title}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-800 mb-3 group-hover:text-amber-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-5 leading-relaxed">
                  {service.description}
                </p>
                <Button 
                  variant="ghost" 
                  className="text-amber-600 hover:text-amber-700 hover:bg-amber-50 p-0 h-auto font-semibold group/btn"
                  asChild
                >
                  <a href="#contact" className="flex items-center gap-2">
                    Get a Quote
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                  </a>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
